import { styled } from "@pigment-css/react";

export const MarkdownBody = styled("div")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[15],
  fontWeight: theme.managementView.font.weight[400],
  lineHeight: theme.managementView.font.lineHeight[164],
  color: theme.managementView.colors.neutral[90],

  "& p, & li, & li > span": {
    fontFamily: theme.managementView.font.familySecondary,
    fontSize: theme.managementView.font.size[15],
    fontWeight: theme.managementView.font.weight[400],
    lineHeight: theme.managementView.font.lineHeight[164],
    color: theme.managementView.colors.neutral[90],
  },
}));
